<template>
<div>
  Ich habe die <span class="text-decoration-underline pointer" @click="clickAgbs">AGBs</span> gelesen und akzeptiere diese
</div>
</template>

<script>
export default {
  name: "AcceptAgbsText",
  methods:{
    clickAgbs(){
      this.$store.commit('selectedDialog', 'AGB');
      this.$store.commit('showDialogContainer', true);
    },
  }
}
</script>

<style scoped>

</style>
